export const isAxiosError = error => {
  return error !== null && typeof error === 'object' && error.isAxiosError === true;
};
